/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Design_DescInputs */

const en_wc_tour_design_desc = /** @type {(inputs: Wc_Tour_Design_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themes, style sets, paragraph spacing, watermarks, page colour and borders.`)
};

/**
* | output |
* | --- |
* | "Themes, style sets, paragraph spacing, watermarks, page colour and borders." |
*
* @param {Wc_Tour_Design_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_design_desc = /** @type {((inputs?: Wc_Tour_Design_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Design_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_design_desc(inputs)
});
export { wc_tour_design_desc as "wc.tour.design.desc" }